<template>
  <div style="width:100%;padding-left:20px;">
      <v-row v-if="classroom"
        align="start"
        justify="start"
      >
        <v-col cols="12"  md="3">
          <h3>{{ uid }}</h3>
          <div class="subheader">{{ classroom.name }}</div>
          <v-date-picker
            class="hidden-sm-and-down"
            color="primary"
            v-model="attendanceDate"
            elevation="1"
            width="250"
            :events="attendanceDateEvents"

          ></v-date-picker>
          <div class="overline">Notable Marks</div>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="item in markedStudents" :key="item.fullName">
                  <td>{{ item.name }}</td>
                  <td>{{ item.calories }}
                    <v-btn
                    small
                    dark
                    class="ma-2" tile :color="attendanceMarkColors[item.attendance.mark]">
                      {{  item.attendance.mark }}
                    </v-btn>

                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-if="false" style="padding-top:20px">
          skedula link<a target="_blank" :href="'https://www.skedula.com/home/classes/?CodeSec=' + classroom.uid">
            <v-icon>external</v-icon>
          </a>
        </div>

        </v-col>
        <v-col cols="12" md="8" sm="12">
          <v-card class="pa-5">
            <v-toolbar flat>
                 <v-card flat>
                   <v-card-title>{{ students.length }}</v-card-title>
                   <v-card-subtitle>STUDENTS</v-card-subtitle>
                 </v-card>
                 <v-card flat class="hidden-sm-and-down">
                   <v-card-title class="text-center">{{ attendanceStats.A }}</v-card-title>
                   <v-card-subtitle>A</v-card-subtitle>
                 </v-card>
                 <v-card flat class="hidden-sm-and-down">
                   <v-card-title class="text-center">{{ attendanceStats.P }}</v-card-title>
                   <v-card-subtitle class="text-center">P</v-card-subtitle>
                 </v-card>
                 <v-card flat class="hidden-sm-and-down">
                   <v-card-title class="text-center"> {{ attendanceStats.L }}</v-card-title>
                   <v-card-subtitle>L</v-card-subtitle>
                 </v-card>
                 <v-card flat class="hidden-sm-and-down">
                   <v-card-title class="text-center">{{ attendanceStats.E }}</v-card-title>
                   <v-card-subtitle>E</v-card-subtitle>
                 </v-card>
                 <v-card flat v-if="attendanceStats.numUnassigned > 0">
                   <v-card-title class="text-center">{{ attendanceStats.numUnassigned }}</v-card-title>
                   <v-card-subtitle class="text-center">UNASSIGNED</v-card-subtitle>
                 </v-card>
                 <v-spacer></v-spacer>
                 <v-btn v-if="!readonly && attendanceStats.numUnassigned > 0"> Mark {{ attendanceStats.numUnassigned }} Unassigned as Present</v-btn>
               </v-toolbar>
            </v-card>
            <v-card class="mt-5">
            <v-data-table
              :headers="table.headers"
              :items="filteredStudents"
              :dense="true"
              :search="table.search"
              :sort-by="['first_name']"
              :hide-default-footer="true"
              :disable-pagination="true"
              :height="550"
            >
            <template v-slot:item="props">
              <tr :class="props.index % 2 === 0 ? 'grey_row' : ''">
                <td style="font-size:.8em" class="text-xs" >
                  {{ props.index + 1}}
                </td>
                <td style="font-size:.8em" class="text-xs">
                  {{ props.item.first_name }}
                </td>
                <td style="font-size:.8em" class="text-xs">
                  {{ props.item.last_name }}
                </td>
                <td class="text-xs-center" v-if="readonly">
                  <v-btn v-if="props.item.attendance"
                  small
                  tile
                  dark
                  class="ma-2" :color="attendanceMarkColors[props.item.attendance.mark]">
                      {{ props.item.attendance.mark }}
                  </v-btn>
                </td>
                <td class="text-xs-center" v-if="!readonly">
                  <v-btn
                  v-for="code in attendanceCodes"
                  :key="code.letter"
                  @click="markAttendance(props.item, code.letter)"
                  x-small
                  dark
                  :loading="(sendingAttendance && props.item.attendance && props.item.attendance.mark === code.letter) || (props.item.attendanceloading && props.item.attendance.mark === code.letter)"
                  :outlined="!props.item.attendance || props.item.attendance.mark != code.letter"
                  class="ma-2" tile :color="code.color">
                      {{ code.letter }}
                  </v-btn>
                </td>

              </tr>
              </template>
            </v-data-table>
          </v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
        </v-card-actions>
        </v-col>
      </v-row>
  </div>
</template>
<style>
  .gdrey_row {
    background-color: #f7f6f6;
  }
</style>
<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')
const moment = require('moment')
const { Confetti } = require('../confetti')
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  props: ['uid'],
  data: () => ({
    user: fb.session.user,
    readonly: true,
    classroom: null,
    sendingAttendance: false,
    attendanceDateStats: {},
    attendanceDate: new Date().toISOString().substr(0, 10),
    attendanceDateMMDDYYYY: null,
    attendanceMap: {},
    attendanceStats: {
      numUnassigned: 0,
      'A':0,
      'P':0,
      'L':0,
      'E':0
    },
    students: [],
    hideProcessed: false,
    attendanceMarkColors: {
      'A':'red',
      'P': 'green',
      'L': 'yellow darken-2',
      'E': 'blue darken-2'
    },
    attendanceCodes: [
      {
        letter: 'A',
        name: 'Absent',
        color: 'red'
      },
      {
        letter: 'P',
        name: 'Present',
        color: 'green'
      },
      {
        letter: 'L',
        name: 'Late',
        color: 'yellow darken-2'
      },
      {
        letter: 'E',
        name: 'Excempt',
        color: 'blue darken-2'
      }
  ],
    breadcrumbs: [{
      text: "Classes",
      to:"/classes/all"
    }],
    table: {
      search: '',
      headers: [
        { width: "20", text: '', value: '' },
        { width: "20%", text: 'First', value: 'first_name' },
        { width: "20%", text: 'Last', value: 'last_name' },
        { width: "50%", text: 'Attendance', value: 'attendance.mark' }
      ]
    }
  }),
  computed: {
    filteredStudents: function () {
      var self = this
      return this.students.filter( student => !self.hideProcessed || !student.attendance)
    },
    numUnassigned: function () {
      var numUnassigned = 0
      this.students.forEach((student, i) => {
        numUnassigned += student.attendance ? 0:1
      });
      return numUnassigned
    },
    markedStudents: function () {
      let notableMarks = 'PLE'
      return this.students.filter( student => student.attendance && notableMarks.indexOf(student.attendance.mark))
    }
  },
  watch: {
    'uid': function (to, from) {
      console.log('uid watched', to)
      this.getClass()
    },
    'attendanceDate': function (to, from) {
      this.getAttendance()
    }
  },
  mounted () {
    console.log('mounted', this.uid)
    this.readonly = true
    this.getClass()
    //this.$confetti.stop();
  },
  methods: {
    confetti: ()=>{
      this.$confetti.start({defaultSize:15, particlesPerFrame:1.5})
      setTimeout(function (){self.$confetti.stop()}, 8000)
    },
    markAttendance: function (student, attendanceGrade) {
      var self = this
      if( student.attendance && student.attendance.mark === attendanceGrade) {
        student.attendance = null
      } else {
        student.attendance = {
          comment: "",
          date: self.attendanceDateMMDDYYYY,
          mark: attendanceGrade,
          studentId: student.uid
        }
        student.attendanceloading = true
        var attendanceRecords = [student.attendance]
        //console.log(attendanceRecords)
        api.post('setSkedulaAttendance', { courseUid: self.uid, attendanceRecords: attendanceRecords }, (data) => {
          student.attendanceloading = false
          self.updateStats()
        })
      }
    },
    getAttendance: function () {

      var self = this
      self.attendanceDateMMDDYYYY = moment(self.attendanceDate).format("MM/DD/YYYY")

      //this.$confetti.stop();

      var params = {
        courseUid: self.uid,
        startDate: self.attendanceDateMMDDYYYY,
        endDate: self.attendanceDateMMDDYYYY
      }
      //console.log(params)
      api.get('getSkedulaAttendance', params, (data) => {
        //console.log(data)
        self.attendanceMap = {}

        var numAttendance = 0
        data.forEach((item, i) => {
          self.attendanceMap[item.studentId] = item.attendance[0]
        });
        //console.log(self.attendanceMap)

        self.students.forEach((student, i) => {
          if (self.attendanceMap.hasOwnProperty(student.uid)){
            //console.log(student)
            student.attendance = self.attendanceMap[student.uid]
            if (student.attendance.mark === 'P') {
              numAttendance ++
            }
          } else {
            student.attendance = null
          }
        });
        self.updateStats()
      })
    },
    updateStats: function () {
      var self = this

      self.attendanceStats.numUnassigned = 0
      self.attendanceStats.A = 0
      self.attendanceStats.P = 0
      self.attendanceStats.L = 0
      self.attendanceStats.E = 0

      this.students.forEach((student, i) => {
         if (student.attendance) {
           self.attendanceStats[student.attendance.mark] ++
         } else {
           self.attendanceStats.numUnassigned ++
         }
       });
    },
    getClass: function (classroom) {
      var self = this
      self.breadcrumbs = [{
        text: "Classes",
        to:"/classes/all"
      }]
      api.get('getClassroom', {courseId: self.uid}, (data) => {
        console.log('clasroom', data)
        self.classroom = data
        self.breadcrumbs.push({
          text: this.classroom.name,
        })

        self.readonly = !(fb.session.user.profile && fb.session.user.profile.skedula_email &&
          self.classroom.teachers.indexOf(fb.session.user.profile.skedula_email) != -1)

        api.get('getClassroomAttendanceStats', {courseUid: self.uid}, (data) => {
            console.log('attendance stats', data)
            self.attendanceDateStats = data
        })
      })
      self.students = []
      api.get('getSkedulaClassroomStudents', {courseUid: self.uid}, (data) => {
        console.log(data)
        data.forEach((item, i) => {
          item.attendanceloading = false
          item.attendance = null
        });
        self.students = data
        self.getAttendance()
      })
    },
    attendanceDateEvents (date) {
      var colors = []
      if (this.attendanceDateStats.hasOwnProperty(date)) {
        if(this.attendanceDateStats[date].A > 0) {
          colors.push('red')
        }
        if(this.attendanceDateStats[date].P > 0) {
          colors.push('green')
        }
        if(this.attendanceDateStats[date].L > 0) {
          colors.push('yellow')
        }
        if(this.attendanceDateStats[date].E > 0) {
          colors.push('blue')
        }
      }
      if (colors.length > 0) {
        return colors
      }
      return false
    },
    submitAllAttendanceRecords: function () {
      var self = this
      var attendanceRecords = []
      self.students.forEach((student, i) => {
        if (student.attendance) {
          student.attendanceloading = true
          attendanceRecords.push(student.attendance)
        }
      });
      self.sendingAllAttendance = true
      console.log(attendanceRecords)

    }
  }
}
</script>
